import styled from "styled-components/macro";
import { COLUMN_GUTTER_WIDTH_PX } from "./columnLayoutConstants";
import { columnResizeHandleStyles } from "./columnResizeHandleStyles";

export const StyledContainer = styled.div`
  #multiverse {
    .inner {
      max-width: none !important;

      .multiverse-resizable-container {
        position: relative;
        display: flex;
        flex-direction: row nowrap;
        align-items: stretch;

        ${columnResizeHandleStyles}

        .resizable-container-with-handles {
          /* overflow-y: auto;
          overflow-x: hidden; */
          overflow: visible;
          scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
          flex-grow: 1;
          width: 100%;
          position: relative;

          /* &::-webkit-scrollbar {
            width: 8px;
          }
          &::-webkit-scrollbar-track {
            background: var(--scrollbar-track);
          }
          &::-webkit-scrollbar-thumb {
            background-color: var(--scrollbar-thumb);
            border-radius: 5px;
          } */

          .editor-stack {
            height: 100%;
            position: relative;
            /* Keep the scroll container clear of both column resize handles. */
            margin: 0 ${COLUMN_GUTTER_WIDTH_PX}px;
            padding: 0 4px;
            overflow-x: hidden;
            /* Mirror space taken by non-overlay scrollbars to keep the editor centered. */
            scrollbar-gutter: stable both-edges;

            &.styled-scrollbars {
              scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);

              &::-webkit-scrollbar {
                width: 10px;
              }
              &::-webkit-scrollbar-track {
                background: var(--scrollbar-track);
              }
              &::-webkit-scrollbar-thumb {
                background-color: var(--scrollbar-thumb);
                border-radius: 5px;
              }
              &::-webkit-scrollbar-thumb:hover {
                background-color: var(--scrollbar-thumb-hover);
              }
            }

            #editor-section.chapter-glue-beta {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            }
          }
        }
      }
    }
  }
`;
